<template>
  <div class="delivery-notice">
    <div class="delivery-notice__title">
      <feather-icon icon="InfoIcon" size="16" class="mr-50" />
      {{ purchased ? 'Seguimiento de tu pedido' : 'Tiempo de entrega' }}
    </div>

    <div class="delivery-notice__text">
      <template v-if="purchased">
        Cada producto es surtido y entregado por el <strong>proveedor seleccionado</strong>.
        Para dudas sobre <strong>entrega, estatus, faltantes o aclaraciones</strong>, contacta al proveedor
        desde el ícono de <strong>WhatsApp</strong>.
      </template>
      <span class="muted">El tiempo mostrado es aproximado.</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InvoiceDeliveryNotice',
  props: {
    // Hablar de seguimiento, faltantes y WhatsApp solo tiene sentido cuando ya hay pedido.
    purchased: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.delivery-notice {
  border: 1px solid #E9ECEF;
  border-left: 4px solid #340668; /* tu morado */
  background: #FAFAFC;
  padding: 12px 14px;
  border-radius: 10px;
}

.delivery-notice__title {
  font-weight: 800;
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.delivery-notice__text {
  font-size: 0.95rem;
  line-height: 1.35;
}

.muted {
  color: #6c757d;
  margin-left: 4px;
}
</style>
